import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProfessionalHomePage from "./pages/ProfessionalHomePage";
import HomePage from "./pages/HomePage";
import DityaTechnologiesHomePage from "./pages/DityaTechnologiesHomePage";
import LandingPage from "./pages/LandingPage";
import ReportEmergencyPage from "./pages/ReportEmergencyPage";
import GuidedRescuePage from "./pages/GuidedRescuePage";
import FamilyDashboardPage from "./pages/FamilyDashboardPage";
import SetupPage from "./pages/SetupPage";
import EmergencyInfoFormPage from "./pages/EmergencyInfoFormPage";
import PublicEmergencyInfoPage from "./pages/PublicEmergencyInfoPage";
import OwnerLoginPage from "./pages/OwnerLoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import GuidePage from "./pages/GuidePage";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import OrderPage from "./pages/OrderPage";
import ProfilePage from "./pages/ProfilePage";
import NearbyServicesPage from "./pages/NearbyServicesPage";
import { AuthProvider } from "./contexts/AuthContext";
import { AdminProvider } from "./contexts/AdminContext";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AdminProvider>
          <Router>
          <Routes>
            <Route path="/" element={<ProfessionalHomePage />} />
            <Route path="/home-v2" element={<HomePage />} />
            <Route path="/old-home" element={<DityaTechnologiesHomePage />} />

            <Route path="/family" element={<FamilyDashboardPage />} />

            <Route path="/guide" element={<GuidePage />} />
            <Route path="/order/:orderId/track" element={<OrderTrackingPage />} />

            <Route path="/order" element={<OrderPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/nearby-services" element={<NearbyServicesPage />} />

            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />

            {/* Short URLs: /:qrId (no /qr prefix) — e.g. emergencyqr.in/DEMO001, app.emergencyqr.in/DEMO001 */}
            <Route path="/:locketId" element={<LandingPage />} />
            <Route path="/:locketId/setup" element={<SetupPage />} />
            <Route path="/:locketId/info" element={<EmergencyInfoFormPage />} />
            <Route path="/:locketId/public" element={<PublicEmergencyInfoPage />} />
            <Route path="/:locketId/edit" element={<OwnerLoginPage />} />
            <Route path="/:locketId/report" element={<ReportEmergencyPage />} />
            <Route path="/:locketId/rescue" element={<GuidedRescuePage />} />
            <Route path="/:locketId/nearby" element={<NearbyServicesPage />} />
            <Route path="/:locketId/forgot-password" element={<ForgotPasswordPage />} />

            <Route
              path="*"
              element={
                <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
                  <div className="bg-white rounded-lg shadow-md border border-slate-200 p-8 text-center max-w-sm">
                    <h1 className="text-2xl font-extrabold text-slate-900 mb-2">Page Not Found</h1>
                    <p className="text-sm text-slate-500 mb-4">The page you're looking for doesn't exist.</p>
                    <a
                      href="/"
                      className="inline-flex items-center gap-2 bg-red-600 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-red-700 transition-colors duration-150"
                    >
                      Go Home
                    </a>
                  </div>
                </div>
              }
            />
          </Routes>
        </Router>
          </AdminProvider>
        </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
